import { render, staticRenderFns } from "./FindOrCreateBrand.vue?vue&type=template&id=8368fc76&"
import script from "./FindOrCreateBrand.vue?vue&type=script&lang=js&"
export * from "./FindOrCreateBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports